import { Component } from '@angular/core';

@Component({
  selector: 'app-account-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class AuthAccountCreateComponent {
  constructor() {}
}
